export const PAGE_VIEW_EVENT_EXCLUDED_PATHS = [
	// /signup always gets redirected to /signup?step-1
	'/signup',
];
